<template>
  <div class="prompt">
    <div class="prompt-card">
      <!-- <img src="@/assets/success.png" height="125" width="125"> -->
      <!-- <h3>Successful</h3> -->
      <h5 v-html="message"></h5>
      <div class="d-flex justify-content-between mt-4">
        <button class="btn-success btn" @click="accept">{{ yes }}</button>
        <button class="btn-success btn" @click="deny">{{ no }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message', 'yes', 'no'],
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    accept() {
      this.$emit('yes');
    },
    deny() {
      this.$emit('no');
    },
  },
};
</script>

<style scoped>

</style>
